export default {
  "brand.name": "USFansLink",
  "nav.home": "Accueil",
  "nav.guide": "Guide du tableau",
  "nav.shopping": "Guide d'achat",
  "nav.categories": "Catégories",
  "nav.visit": "Visiter le site principal",
  "lang.en": "English",
  "lang.pl": "Polski",
  "lang.es": "Español",
  "lang.fr": "Français",
  "footer.tagline": "Un centre de ressources indépendant pour le tableau USFans.",
  "footer.navTitle": "Explorer",
  "footer.resourcesTitle": "Ressources",
  "footer.disclaimerTitle": "Avertissement",
  "footer.disclaimer": "USFansLink.asia est une ressource informative indépendante. Nous ne sommes pas affiliés à USFans ni au site principal. Vérifiez toujours les informations actuelles avant tout achat ou paiement.",
  "footer.home": "Accueil",
  "footer.guide": "Guide du tableau",
  "footer.mainSite": "Site principal",
  "footer.copyright": "© 2026 USFansLink.asia. Tous droits réservés.",
  "notfound.title": "Page introuvable",
  "notfound.body": "La page que vous recherchez n'existe pas ou a été déplacée.",
  "notfound.home": "Retour à l'accueil",
};